import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ThumbnailCard from '../components/ThumbnailCard';
import { getContentByIds } from '../data/mockData';
import { motion } from 'framer-motion';

const MyListContainer = styled.div`
  min-height: 100vh;
  background-color: #141414;
  padding: 2rem 4% 4rem;

  @media (max-width: 768px) {
    padding: 1.5rem 20px 3rem;
  }
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: white;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }
`;

const WatchlistGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 0.8rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 0.6rem;
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 4rem 0;
  color: #808080;
`;

const EmptyTitle = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: white;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const EmptyText = styled.p`
  font-size: 1.1rem;
  line-height: 1.5;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const BrowseButton = styled.button`
  background: #E50914;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #d40813;
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    padding: 0.6rem 1.5rem;
    font-size: 1rem;
  }
`;

const ListInfo = styled.div`
  margin-bottom: 2rem;
  color: #808080;
  font-size: 1rem;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }
`;

const MyList = () => {
  const { currentProfile } = useSelector(state => state.user);

  const watchlistContent = getContentByIds(currentProfile?.watchlist || []);

  const handleBrowse = () => {
    window.location.href = '/browse';
  };

  return (
    <MyListContainer>
      <PageTitle>My List</PageTitle>

      {watchlistContent.length > 0 ? (
        <>
          <ListInfo>
            {watchlistContent.length} title{watchlistContent.length !== 1 ? 's' : ''} in your list
          </ListInfo>

          <WatchlistGrid
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            {watchlistContent.map((content, index) => (
              <ThumbnailCard
                key={content.id}
                content={content}
                index={index}
              />
            ))}
          </WatchlistGrid>
        </>
      ) : (
        <EmptyState>
          <EmptyTitle>Your list is empty</EmptyTitle>
          <EmptyText>
            Movies and TV shows you add to your list will appear here.
            <br />
            Start browsing to find something to watch!
          </EmptyText>
          <BrowseButton onClick={handleBrowse}>
            Browse Titles
          </BrowseButton>
        </EmptyState>
      )}
    </MyListContainer>
  );
};

export default MyList;